<template>
  <div>
    <customModal ref="customModal" v-if="modalData" v-show="modalData"
                 :onModalClose="closeModal"
                 :onModalAccept="acceptModal"
                 :modalData="modalData">
    </customModal>
  </div>
</template>

<script>

import customModal from "../../../components/modals/customModal";
import moment from 'moment';
import api from '@/api'

export default {
  components: {
    customModal,
  },
  props: ['drug', 'closeModal', 'type'],
  data() {
    return {
      modalData: null,
    }
  },
  mounted() {
    this.modalData = {
      blackListId: this.drug.black_list && this.drug.black_list.id || null,
      header: 'Запись в черном списке',
      body: this.generateText(),
      inputs: [{label: 'Комментарий', data: null, placeholder: 'Причина игнорирования...'}],
      dateSelect: {
        title: 'Новая актульная дата',
        minDateSelect: moment().toISOString(),
        date: moment().add(15, 'days').toISOString()
      },
      // checkBox: {
      //   label: 'Игнорировать для автосписка',
      //   data: this.drug.black_list && this.drug.black_list.is_active || true,
      // },
      acceptBtnText: 'Сохранить'
    };
  },
  methods: {
    async acceptModal() {
      this.modalData.errorMessage = null;
      if (!this.modalData.inputs[0].data || this.modalData.inputs[0].data.length < 5) {
        this.modalData.errorMessage = 'Комментарий не может быть короче 5-ти символов';
        this.$refs.customModal.acceptBtnLoading = false;
        return;
      }
      let {data} = await api.post('/blacklist/update', {
        id: this.modalData.blackListId,
        drug_id: this.drug.id,
        type: this.type,
        comment: this.modalData.inputs[0].data,
        actual_date: this.modalData.dateSelect.date,
        // is_active: this.modalData.checkBox && this.modalData.checkBox.data,
        is_active: true,
      });
      if (!data.success) {
        toastr['warning'](data.message, 'Ошибка!');
      } else {
        toastr['success'](data.message, 'Обновлено!');
        this.drug.black_list = data.record;
        this.closeModal({...this.drug});
      }
    },
    generateText() {
      let text = '<p>препарат: <strong>' + this.drug.title + '</strong></p>';
      if (this.drug.black_list) {
        text += '<p>Игнорирование актуально до: ' + moment(this.drug.black_list.actual_date).format('DD.MM.YYYY') + '</p>';
        if (this.drug.black_list && this.drug.black_list.comments && this.drug.black_list.comments.length) {
          text += '<div class="comments">';
          this.drug.black_list.comments.reverse().forEach((c) => {
            text += '<div class="comment">';
            text += '<p class="author">' + c.user_name + ' (' + c.user_id + ') <span class="actual_date">' + moment(c.actual_date).format('DD.MM.YYYY') + '</span> <span class="badge ' + (c.is_active ? 'active' : '') + '">' + (c.is_active ? 'Ативно' : 'Не активно') + '</span></p>';
            text += '<p class="comment">' + c.comment + '</p>';
            text += '<p class="date">' + c.date + '</p>';
            text += '</div>';
          });
          text += '</div>';
        }
      }
      return text;
    },
  }
}
</script>
